import React, { useState, useEffect } from "react";
import Header from './Header';
import Footer from './Footer';
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import UserService from "../services/EmployeeService";
import StorageService from "../services/StorageService";
import deviops_logo from "./../assets/images/deviops_logo.png";

const Layout = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedSubMenu, setSelectedSubMenu] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const [menuData, setMenuData] = useState([]);

  const normalize = (url = "") =>
    url.replace(/^#\/?/, "").replace(/^\/+/, "").toLowerCase();


  useEffect(() => {
    if (!StorageService.loginData()) {
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
        navigate("/");
      };
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const currentPath = location.pathname.startsWith('/cpnl/')
      ? location.pathname.substring(5) // Remove '/cpnl/'
      : location.pathname;
    setSelectedSubMenu(normalize(currentPath));

    if (menuData && menuData.length) {
      const found = menuData.find((m) => normalize(m.menuURL).split("/")[0] === normalize(currentPath).split("/")[0]);
      if (found) {
        setOpenMenu(`menu-${found.id}`);
      }
    }
  }, [location.pathname, menuData]);

  const fetchUserMenu = async () => {
    try {
      var employeeId = localStorage.getItem("employeeId");
      const res = await UserService.getUserMenu(employeeId);
      setMenuData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching menu:", err);
    }
  };

  useEffect(() => {
    fetchUserMenu();
  }, []);

  return (
    <div>
      <style>{`
        /* Sidebar colors */
        .pc-submenu .pc-link:hover {
          background-color: #4e5c78 !important;
          color: #fff !important;
        }

        /* Active submenu link */
        .pc-submenu .pc-link.active {
          background-color: #3f4d67 !important;
          color: #fff !important;
          font-weight: 700 !important;
        }

        /* Active submenu <li>  */
        .pc-submenu li.active > .pc-link {
          background-color: #3f4d67 !important;
          color: #fff !important;
          font-weight: 700 !important;
        }

        /* Active parent menu item */
        .pc-item.active > .pc-link {
          background-color: #3f4d67 !important;
          color: #fff !important;
          font-weight: 700 !important;
        }

        /* Scrollbar */
        .pc-sidebar::-webkit-scrollbar {
          width: 6px;
        }
        .pc-sidebar::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }
        .pc-sidebar::-webkit-scrollbar-thumb:hover {
          background: #555;
        }

        /* small padding for submenu items */
        .pc-submenu .pc-link {
          padding-left: 36px;
        }
      `}</style>

      <nav
        id="pc-sidebar"
        className="pc-sidebar"
        style={{
          height: "100vh",
          overflowY: "auto",
          position: "fixed",
          top: 0,
          left: 0,
        }}
      >
        <div className="navbar-wrapper">
          <div className="m-header">
            <img src={deviops_logo} style={{ height: '75px' }}></img>
            <span className="fw-bold text-white p-3 mt-3" style={{ fontSize: "1.2rem" }}>
              DeviOps
            </span>

          </div>

          <div className="navbar-content">
            <ul className="pc-navbar d-block">
              {menuData.map((m) => {
                const menuKey = `menu-${m.id}`;
                const mUrlNormalized = normalize(m.menuURL).split("/")[0]; // parent segment

                // mark parent active if openMenu matches or if one of its children is active
                const parentActive = openMenu === menuKey || mUrlNormalized === selectedSubMenu;

                return (
                  <li className={`pc-item ${parentActive ? "active" : ""}`} key={menuKey}>
                    {!m.children || m.children.length === 0 ? (
                      <Link
                        className="pc-link"
                        to={"/cpnl/" + normalize(m.menuURL)}
                      >
                        <span className="pc-micon" dangerouslySetInnerHTML={{ __html: m.menuIcon }} />
                        <span className="pc-mtext">{m.name}</span>
                      </Link>
                    ) : (
                      <>
                        <div
                          className="pc-link"
                          onClick={() => setOpenMenu(openMenu === menuKey ? null : menuKey)}
                          style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <span className="pc-micon" dangerouslySetInnerHTML={{ __html: m.menuIcon }} />
                            <span className="pc-mtext" style={{ marginLeft: 8 }}>{m.name}</span>
                          </div>
                          <span className="pc-arrow">{openMenu === menuKey ? "▼" : "▶"}</span>
                        </div>

                        {/* Submenu: show when clicked OR when current URL belongs to this parent */}
                        {(openMenu === menuKey || mUrlNormalized === selectedSubMenu) && (
                          <ul className="pc-submenu">
                            {m.children.map((cm) => {
                              const liActive = normalize(cm.menuURL) === selectedSubMenu;
                              return (
                                <li key={cm.id || cm.menuURL} className={liActive ? "active" : ""}>
                                  <Link
                                    to={"/cpnl/" + normalize(cm.menuURL)}
                                    className={`pc-link ${liActive ? "active" : ""}`}
                                  >
                                    <span className="pc-micon" dangerouslySetInnerHTML={{ __html: cm.menuIcon }} />
                                    <span className="pc-mtext">{cm.name}</span>
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </>
                    )}
                  </li>
                );
              })}

              {/* <li className="pc-item">
                <Link
                  className="pc-link"
                  to="/cpnl/dailyreport/view"
                  onClick={() => handleSelectSubMenu("reports")}
                >
                  <span className="pc-micon">
                    <i class="ph ph-chart-bar"></i>
                  </span>
                  <span className="pc-mtext">Daily Report Progress</span>
                </Link>
              </li> */}
              {/* <li className="pc-item">
                <Link
                  className="pc-link"
                  to="/cpnl/pettycash/view"
                  onClick={() => handleSelectSubMenu("reports")}
                >
                  <span className="pc-micon">
                    <i class="ph ph-cash-register"></i>
                  </span>
                  <span className="pc-mtext">Petty Cash</span>
                </Link>
              </li> */}

              {/* <li className={`pc-item ${selectedSubMenu === "dashboard" ? "active" : ""}`}>
                <Link
                  className="pc-link"
                  to="/cpnl/dashboard"
                  onClick={() => handleSelectSubMenu("dashboard")}
                >
                  <span className="pc-micon"><i className="ph ph-house-line" /></span>
                  <span className="pc-mtext">Dashboard</span>
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>

      <Header />
      <div className="pc-container">
        <div className="pc-content">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
